<template>
  <div class="pt-3 px-3">
    <ValidationObserver ref="form" tag="div" class="row">
      <div class="col-12">
        <div class="row">
          <template
            v-if="
              currentStatusTarget &&
                currentStatusTarget.needReasonType &&
                !readonly
            "
          >
            <div class="col-12 col-lg-5 col-xl-4 border-right">
              <div class="row">
                <div class="col-12">
                  <CustomDropDown
                    v-model="viewmodel.reasonType"
                    label="Tipo de Razón:"
                    regular-label
                    fieldkey="id"
                    fieldname="description"
                    :options="catalogReasonTypes"
                    placeholder="Seleccione"
                  />
                </div>
                <div class="col-12 pt-2">
                  <div class="d-flex justify-content-between">
                    <span class="small text-gray">
                      <i class="far fa-info-circle fa-fw" />
                      <span>Selección múltiple.</span>
                    </span>
                    <ActionButton
                      text="Añadir"
                      variant="success"
                      i="fas fa-file-plus"
                      @click="addReasonType"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-7 col-xl-8">
              <ValidationProvider
                v-slot="{ errors }"
                vid="reasonTypes"
                mode="lazy"
                rules="required"
                :custom-messages="{
                  required: 'Favor seleccionar tipo(s) de razón(es).',
                }"
              >
                <label class="text-gray">Razones Seleccionadas:</label>
                <div class="d-flex flex-wrap px-xl-3 pb-3">
                  <div
                    v-for="(item, i) in model.reasonTypes"
                    :key="i"
                    class="py-1 mx-1"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between py-2 py-lg-1 px-3 px-xl-4 text-xl-left border"
                      :style="{ 'border-radius': '10rem' }"
                    >
                      <span class="mr-2" v-text="item.description" />
                      <span
                        :style="{ cursor: 'pointer' }"
                        @click="removeReasonType(item.id)"
                      >
                        <i
                          class="far fa-times-circle text-danger d-none d-xl-inline"
                        />
                        <i
                          class="far fa-times-circle text-danger fa-2x d-xl-none"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <input v-model="model.reasonTypes" type="hidden" />
                <Error
                  v-if="errors[0]"
                  variant="no-border"
                  :message="errors[0]"
                />
              </ValidationProvider>
            </div>
          </template>

          <template
            v-if="
              (currentStatusTarget && currentStatusTarget.needReason) ||
                readonly
            "
          >
            <div class="col-12 pt-2">
              <div class="d-flex flex-wrap pb-3">
                <div
                  v-for="(item, i) in model.reasonTypes"
                  :key="i"
                  class="py-1 mx-1"
                >
                  <div
                    class="d-flex align-items-center justify-content-between py-2 py-lg-1 px-3 px-xl-4 text-xl-left border"
                    :style="{ 'border-radius': '10rem' }"
                  >
                    <span class="mr-2" v-text="item.description" />
                  </div>
                </div>
              </div>
              <div class="border-bottom" />
            </div>

            <div class="col-12 pt-2">
              <ValidationProvider
                v-slot="{ errors, validate }"
                mode="lazy"
                rules="required"
                :custom-messages="{ required: 'Favor escriba razón.' }"
              >
                <CustomTextArea
                  v-model="model.reason"
                  :disabled="readonly"
                  label="Razón:"
                  regular-label
                  :maxlength="3000"
                  show-char-count
                  :count-classes="['d-block text-right', 'small-counter']"
                  :error="errors[0]"
                  :custom-error-msg="errors[0]"
                  @input="validate"
                />
              </ValidationProvider>
            </div>
          </template>
        </div>
      </div>

      <div v-if="!readonly" class="col-12 pt-2 text-right">
        <ActionButton
          text="Cancelar"
          i="fas fa-times-circle"
          variant="custom-btn-return outline-danger"
          class="mr-2"
          @click="cancel"
        />
        <ActionButton
          text="Continuar"
          i="fas fa-arrow-alt-circle-right"
          variant="custom-btn-return outline-success"
          @click="submit"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import Error from 'custom-error';
import ActionButton from 'ActionButton';
import alert from '@/mixin/alert.mixin';

const initialModel = () => ({ reasonTypes: [], reason: null });

export default {
  name: 'ReturnForm',
  mixins: [alert],
  components: {
    CustomDropDown,
    CustomTextArea,
    Error,
    ActionButton,
  },
  props: {
    // { id: null, name: null, reason: null, reasonTypes: [] }
    currentStatus: {
      required: true,
      default: null,
      validator: (prop) => typeof prop === 'object' || prop === null,
    },
    currentStatusTarget: {
      required: true,
      default: null,
      validator: (prop) => typeof prop === 'object' || prop === null,
    },
    readonly: { type: Boolean, default: false },
  },
  data: () => ({ model: initialModel(), viewmodel: { reasonType: null } }),
  computed: {
    catalogReasonTypes() {
      if (!this.currentStatusTarget) return [];
      const addedReasonTypesIds = this.model.reasonTypes.map((x) => x.id);
      return (
        this.currentStatusTarget?.reasonTypes?.filter(
          (x) => !addedReasonTypesIds.includes(x.id)
        ) || []
      );
    },
  },
  methods: {
    addReasonType() {
      const item = this.viewmodel.reasonType;
      if (item) {
        this.model.reasonTypes.push(item);
        this.viewmodel.reasonType = null;
        this.$refs['form'].reset();
      }
    },
    removeReasonType(id) {
      const index = this.model.reasonTypes.findIndex((x) => x.id === id);
      this.model.reasonTypes.splice(index, 1);
    },
    async submit() {
      if (this.readonly) return;
      const valid = await this.$refs['form'].validate();
      if (valid) {
        const model = {
          currentStatusTargetId: this.currentStatusTarget.id,
          model: this.model,
        };
        this.$emit('submit', model);
      } else {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información solicitada.',
          'error'
        );
      }
    },
    cancel() {
      this.viewmodel.reasonType = null;
      this.model = initialModel();
      this.$refs['form'].reset();
      this.$emit('cancel');
    },
  },
  created() {
    if (this.currentStatus) {
      const { reason, reasonTypes } = this.currentStatus;
      this.model = {
        reason,
        reasonTypes: reasonTypes.map(
          ({ statusReasonTypeId, statusReasonType }) => ({
            id: statusReasonTypeId,
            description: statusReasonType,
          })
        ),
      };
    }
  },
};
</script>
